class VwHastamuracaatListeDTO {
    id?: number = 0;
    tarih?: string = null;
    kimlikId?: number = null;
    servis?: string = "";
    doktor?: string = "";
    iptal?: string = "H";
    organizasyonId?: number = null;
    bagliOrganizasyonId?: number = null;
    kurum?: string = "";
    tarife?: string = "";
    ucrettoplam?: number = null;
    odenentoplam?: number = null;
    kalantoplam?: number = null;
    treekey?: string = "";
    organizasyonAdi?: string = "";
    doktorId?: number = null;
    kurumId?: number = null;
    ekleyenKullanici?: number = null;
    kayitTipi?: string = "A";
}
export default VwHastamuracaatListeDTO;